import Immutable from "immutable";
import React from "react";
import {
	AIRCRAFT_DATA_URL,
	AIRPORTS_URL,
	COUNTRIES_URL,
	FLIGHT_URL,
	OPERATORS_URL,
	renderLink,
	SUBDIVISIONS_URL,
} from "../search/result/renderers";
import { ScheduleStopsDisplay } from "./result/ScheduleStopsDisplay";

export const renderScheduleFlightLink = (flight) => {
	if (Immutable.isImmutable(flight)) {
		flight = flight.toJS();
	}
	const { name, code } = flight;
	return renderLink(
		`${FLIGHT_URL}${name.replace(" ", "-")}/${code}`,
		name.replace("-", " "),
	);
};

export const renderScheduleTitleAirportLink = ({ code }) =>
	renderLink(`${AIRPORTS_URL}${code}`, code);

export const renderScheduleTitleCountryLink = ({ code, name }) =>
	renderLink(`${COUNTRIES_URL}${code}`, name);

export const renderScheduleTitleSubdivisionLink = (subdivision) => {
	if (!subdivision) {
		return null;
	}
	return renderLink(
		`${SUBDIVISIONS_URL}${subdivision.country_code}/${subdivision.code}`,
		subdivision.name,
	);
};

export const renderScheduleAirlineLink = (airline) => {
	if (!airline) {
		return "-";
	}
	if (Immutable.isImmutable(airline)) {
		airline = airline.toJS();
	}
	return renderLink(
		`${OPERATORS_URL}${airline.code}`,
		airline.name || airline.code,
	);
};

export const renderScheduleEquipmentLink = (equipment) => {
	if (!equipment) {
		return "-";
	}

	return renderLink(`${AIRCRAFT_DATA_URL}${equipment}`, equipment);
};

export function renderScheduleDataFlightLink(flight) {
	return renderScheduleFlightLink(flight.toJS());
}

export function renderScheduleDataStopsDisplay(stops) {
	const stopsObject = stops.toJS();
	return (
		<ScheduleStopsDisplay
			stops={stopsObject.stops}
			codes={stopsObject.codes}
		/>
	);
}

export function renderAirportChLink(code) {
	return renderLink(`${AIRPORTS_URL}${code}`, code);
}

export const renderServiceTypeName = (value) => value?.get("name");
